import Site from "./Site";

export default class StockHistory {
  constructor(
    public site: Site,
    public itemStockHistory: Record<number, number[]>
  ) {
  }
}